import { Controller } from "stimulus"
import Utility from '../classes/Utility';

const breakpointsToWidthMapping = {
  0: '100vw',
  480: '480px',
  640: '640px',
  768: '768px',
  970: '970px',
  1170: '1170px',
}

const breakpoints = [
  1170,
  970,
  768,
  640,
  480,
  0
]

class IndexNav extends Controller {
  connect() {
    this.__calculateAndApplyPadding();
    window.addEventListener('resize', () => { this.__calculateAndApplyPadding()})
  }

  __calculateAndApplyPadding() {
    const width = Utility.getBrowserWidth();
    const breakpointValue = breakpoints.reduce((acc, breakpoint) => {
      if (width > breakpoint && acc == 0) {
        return breakpoint;
      }
      return acc;
    }, 0)
    this.element.style.paddingLeft = `calc((100vw - ${(breakpointsToWidthMapping[breakpointValue])}) / 2 + 1rem)`;
  }
}

export default IndexNav;

